import React from 'react';
import { ThemeProvider, LanguageProvider } from '@components';
import { MDXProvider } from '@mdx-js/react';
import { NormalImage, NormalVideo, LongImage, Carousel } from './blogImage';

const components = {
  Carousel,
  LongImage,
  NormalImage,
  NormalVideo,
};

export const wrapRootElement = ({ element }) => (
  <LanguageProvider>
    <ThemeProvider>
      <MDXProvider components={components}>{element}</MDXProvider>
    </ThemeProvider>
  </LanguageProvider>
);
